import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { graphql, compose } from "react-apollo";

import AuthCode from "react-auth-code-input";

import { useAuthState, useAuthDispatch } from "../Context";
import { notify } from "../generic";
import { validate } from "../../api/queries/utilisateur.mutations";
import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import { Nav, Row, Col } from "react-bootstrap";

function ValidatePage(props) {
  const [validationCode, setValidationCode] = useState("");

  const location = useLocation();
  const params = useParams();

  const { validationToken = "" } = params;

  const handleValidationCodeChange = res => {
    setValidationCode(res);

    if (res.length === 5) {
      _mutateValidateUser({ validationToken, validationCode: res });
    }
  };

  const submitValidationCode = () => {
    if (validationCode.length === 5) {
      _mutateValidateUser({ validationToken, validationCode });
    } else {
      notify("error", "Code trop court");
    }
  };

  const dispatch = useAuthDispatch();
  const navigate = useNavigate();

  const _mutateValidateUser = async ({ validationToken, validationCode }) => {
    try {
      return props
        .validate({
          variables: {
            validationToken,
            validationCode
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.validate;

          if (type === "success") {
            const { user } = JSON.parse(details);

            localStorage.setItem("currentUser", JSON.stringify(user));

            setTimeout(() => navigate(0), 350);
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      notify("error", error.message);
      setValidationCode("");
    }
  };

  return (
    <div>
      <div className="sidenav small">
        <div className="login-main-text">
          <h2>Penge</h2>
          <h3>Validez votre compte</h3> <a href="/logout">&nbsp; Déconnexion</a>
        </div>
      </div>
      <div className="main expanded">
        <div className="validate-form">
          <h1>Code de confirmation</h1>
          <p>
            Vous devriez avoir reçu un e-mail contenant un code de validation,
            merci de renseigner le code dans le champ suivant.
          </p>
          <AuthCode
            onChange={handleValidationCodeChange}
            length={5}
            containerClassName={"authCode"}
            inputClassName={"authCodeInput"}
          />
          <Row>
            <Col xs={4}></Col>
            <Col xs={12} sm={4}>
              {" "}
              <a
                className="btn btn-primary"
                onClick={() => submitValidationCode()}
                style={{ width: "100%" }}
              >
                Confirmer
              </a>
            </Col>
            <Col xs={4}></Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default graphql(validate, {
  name: "validate"
})(ValidatePage);
